import React, { useState } from 'react';
import PageCommunitySelectWrapper from '../../components/common/page_community_select_wrapper';
import { LeadsWidget } from '../../components/dashboard/leads_widget';
import { useCommunitySelectHistory } from '../../hooks/use_community_select_history';

const Leads = () => {
    const [ selNHID, setSelNHID ] = useState<number>(null);

    const handleSelect = useCommunitySelectHistory((selNHID: number) => {
        setSelNHID(selNHID);
    });

    return (
        <>
            <PageCommunitySelectWrapper
                label="All Leads for"
                handleSelect={handleSelect}
                selNHID={selNHID}
            />
            <section>
                <div className="container max-w-none 2xl:container mt-4 sm:mt-6 md:mt-8 2xl:mt-10">
                    <LeadsWidget
                        selNHID={selNHID}
                        showTable={true}
                    />
                </div>
            </section>
        </>
    );
};

export default Leads;
